import routes from '../router/routes';

export const defaultTDK = {
  title: '专业的酒吧霸屏大屏互动点歌软件_松鼠互娱',
  keywords: '酒吧霸屏,大屏互动,扫码点歌,祝福上墙,酒吧游戏',
  description: '松鼠互娱是专业的酒吧霸屏大屏互动点歌软件，应用于各类酒吧、餐吧、烧烤吧、音乐餐厅等场所，开启智慧娱乐新体验'
};

function joinPaths(parentPath, childPath) {
  const normalizedParent = parentPath && parentPath !== '/' ? parentPath.replace(/\/$/, '') : parentPath;

  if (!childPath) return normalizedParent || '/';
  if (childPath.startsWith('/')) return childPath;

  const childWithSlash = childPath.startsWith('/') ? childPath : `/${childPath}`;
  if (!normalizedParent || normalizedParent === '/') return childWithSlash;
  return `${normalizedParent}${childWithSlash}`;
}

function buildSeoRouteMap(routeRecords) {
  const map = {};

  function walk(list, parentPath) {
    (list || []).forEach((route) => {
      const fullPath = joinPaths(parentPath, route.path);
      if (route.meta && route.meta.tdk) {
        map[fullPath] = route.meta.tdk;
      }
      if (route.children && route.children.length) {
        walk(route.children, fullPath);
      }
    });
  }

  walk(routeRecords, '');
  return map;
}

// 路由路径 -> TDK 配置映射（从路由表自动生成，避免多处维护）
export const seoRouteMap = buildSeoRouteMap(routes);

export const updateTDK = (path) => {
  const config = seoRouteMap[path] || defaultTDK;
  
  // 更新 Title
  document.title = config.title;
  
  // 更新 Meta Keywords
  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    document.head.appendChild(keywordsMeta);
  }
  keywordsMeta.setAttribute('content', config.keywords);
  
  // 更新 Meta Description
  let descMeta = document.querySelector('meta[name="description"]');
  if (!descMeta) {
    descMeta = document.createElement('meta');
    descMeta.setAttribute('name', 'description');
    document.head.appendChild(descMeta);
  }
  descMeta.setAttribute('content', config.description);
};
